// // frontend/src/components/booking/BookingHistory.jsx
// import React from 'react';
// import { Link } from 'react-router-dom';

// const BookingHistory = ({ bookings, onCancelBooking }) => {
//   const formatTime = (dateString) => {
//     return new Date(dateString).toLocaleTimeString('en-US', {
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: false
//     });
//   };

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString('en-US', {
//       month: 'short',
//       day: 'numeric',
//       year: 'numeric'
//     });
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case 'confirmed':
//         return 'bg-green-100 text-green-800';
//       case 'cancelled':
//         return 'bg-red-100 text-red-800';
//       case 'completed':
//         return 'bg-blue-100 text-blue-800';
//       default:
//         return 'bg-gray-100 text-gray-800';
//     }
//   };

//   const canCancelBooking = (booking) => {
//     const departureDate = new Date(booking.flight?.departure_time);
//     const now = new Date();
//     const hoursDiff = (departureDate - now) / (1000 * 60 * 60);
    
//     return booking.booking_status === 'confirmed' && hoursDiff > 24;
//   };

//   if (bookings.length === 0) {
//     return (
//       <div className="p-12 text-center">
//         <div className="text-6xl mb-4">✈️</div>
//         <h3 className="text-xl font-semibold text-gray-700 mb-2">
//           No bookings yet
//         </h3>
//         <p className="text-gray-500 mb-6">
//           Start planning your next trip!
//         </p>
//         <Link
//           to="/"
//           className="btn btn-primary"
//         >
//           Book Your First Flight
//         </Link>
//       </div>
//     );
//   }

//   return (
//     <div className="divide-y divide-gray-200">
//       {bookings.map((booking) => (
//         <div key={booking.id} className="p-6">
//           <div className="flex flex-col lg:flex-row lg:items-center justify-between">
//             <div className="flex-1">
//               <div className="flex items-center justify-between mb-4">
//                 <div>
//                   <h3 className="text-lg font-medium text-gray-900">
//                     {booking.flight?.origin_city} → {booking.flight?.destination_city}
//                   </h3>
//                   <p className="text-sm text-gray-500">
//                     Booking Reference: <span className="font-medium">{booking.booking_reference}</span>
//                   </p>
//                 </div>
//                 <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(booking.booking_status)}`}>
//                   {booking.booking_status.charAt(0).toUpperCase() + booking.booking_status.slice(1)}
//                 </span>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-600">
//                 <div>
//                   <p className="font-medium text-gray-900">Flight Details</p>
//                   <p>{booking.flight?.airline_name} {booking.flight?.flight_number}</p>
//                   <p>{booking.flight?.origin_airport} → {booking.flight?.destination_airport}</p>
//                 </div>
                
//                 <div>
//                   <p className="font-medium text-gray-900">Travel Date</p>
//                   <p>{formatDate(booking.flight?.departure_time)}</p>
//                   <p>{formatTime(booking.flight?.departure_time)} - {formatTime(booking.flight?.arrival_time)}</p>
//                 </div>

//                 <div>
//                   <p className="font-medium text-gray-900">Passengers</p>
//                   <p>{booking.passengers?.length} passenger{booking.passengers?.length > 1 ? 's' : ''}</p>
//                   <p className="text-lg font-semibold text-blue-600">${booking.total_amount}</p>
//                 </div>
//               </div>
//             </div>

//             <div className="mt-4 lg:mt-0 lg:ml-6 flex flex-col sm:flex-row gap-2">
//               <Link
//                 to={`/booking/${booking.id}/details`}
//                 className="btn btn-secondary text-sm px-4 py-2"
//               >
//                 View Details
//               </Link>
              
//               {canCancelBooking(booking) && (
//                 <button
//                   onClick={() => onCancelBooking(booking.id)}
//                   className="btn btn-danger text-sm px-4 py-2"
//                 >
//                   Cancel
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default BookingHistory;



// frontend/src/components/booking/BookingHistory.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const BookingHistory = ({ bookings, onCancelBooking }) => {
  const formatTime = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    } catch (error) {
      return 'N/A';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    } catch (error) {
      return 'N/A';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed':
        return 'bg-green-100 text-green-800';
      case 'cancelled':
        return 'bg-red-100 text-red-800';
      case 'completed':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getFlightInfo = (booking) => {
    // Try different sources for flight information
    console.log('Processing booking:', booking);
    
    const flight = booking.flight || booking.flight_details || {};
    
    return {
      airline_name: flight.airline_name || 'Unknown Airline',
      flight_number: flight.flight_number || 'N/A',
      origin_airport: flight.origin_airport || flight.origin || 'N/A',
      destination_airport: flight.destination_airport || flight.destination || 'N/A', 
      origin_city: flight.origin_city || flight.origin || 'N/A',
      destination_city: flight.destination_city || flight.destination || 'N/A',
      departure_time: flight.departure_time,
      arrival_time: flight.arrival_time
    };
  };

  const canCancelBooking = (booking) => {
    const flightInfo = getFlightInfo(booking);
    if (!flightInfo.departure_time) return false;
    
    try {
      const departureDate = new Date(flightInfo.departure_time);
      const now = new Date();
      const hoursDiff = (departureDate - now) / (1000 * 60 * 60);
      
      return booking.booking_status === 'confirmed' && hoursDiff > 24;
    } catch (error) {
      return false;
    }
  };

  // Debug logging
  console.log('BookingHistory received bookings:', bookings);

  if (bookings.length === 0) {
    return (
      <div className="p-12 text-center">
        <div className="text-6xl mb-4">✈️</div>
        <h3 className="text-xl font-semibold text-gray-700 mb-2">
          No bookings yet
        </h3>
        <p className="text-gray-500 mb-6">
          Start planning your next trip!
        </p>
        <Link
          to="/"
          className="btn btn-primary"
        >
          Book Your First Flight
        </Link>
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-200">
      {bookings.map((booking) => {
        const flightInfo = getFlightInfo(booking);
        
        return (
          <div key={booking.id} className="p-6">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between">
              <div className="flex-1">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-lg font-medium text-gray-900">
                      {flightInfo.origin_city} → {flightInfo.destination_city}
                    </h3>
                    <p className="text-sm text-gray-500">
                      Booking Reference: <span className="font-medium">{booking.booking_reference}</span>
                    </p>
                  </div>
                  <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(booking.booking_status)}`}>
                    {booking.booking_status.charAt(0).toUpperCase() + booking.booking_status.slice(1)}
                  </span>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-600">
                  <div>
                    <p className="font-medium text-gray-900">Flight Details</p>
                    <p>{flightInfo.airline_name} {flightInfo.flight_number}</p>
                    <p>{flightInfo.origin_airport} → {flightInfo.destination_airport}</p>
                  </div>
                  
                  <div>
                    <p className="font-medium text-gray-900">Travel Date</p>
                    <p>{formatDate(flightInfo.departure_time)}</p>
                    <p>{formatTime(flightInfo.departure_time)} - {formatTime(flightInfo.arrival_time)}</p>
                  </div>

                  <div>
                    <p className="font-medium text-gray-900">Passengers</p>
                    <p>{booking.passengers?.length || 0} passenger{(booking.passengers?.length || 0) > 1 ? 's' : ''}</p>
                    <p className="text-lg font-semibold text-blue-600">
                      ${booking.total_amount ? booking.total_amount.toFixed(2) : '0.00'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-4 lg:mt-0 lg:ml-6 flex flex-col sm:flex-row gap-2">
                <Link
                  to={`/booking/${booking.id}/details`}
                  className="btn btn-secondary text-sm px-4 py-2"
                >
                  View Details
                </Link>
                
                {canCancelBooking(booking) && (
                  <button
                    onClick={() => onCancelBooking(booking.id)}
                    className="btn btn-danger text-sm px-4 py-2"
                  >
                    Cancel
                  </button>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BookingHistory;